const indexItems = [
  { label: '热血战斗', count: 128, icon: 'ri-fire-line', color: 'text-primary-500' },
  { label: '恋爱甜宠', count: 96, icon: 'ri-heart-line', color: 'text-primary-400' },
  { label: '悬疑推理', count: 74, icon: 'ri-search-eye-line', color: 'text-accent-500' },
  { label: '日常治愈', count: 85, icon: 'ri-cup-line', color: 'text-accent-400' },
  { label: '异世界冒险', count: 112, icon: 'ri-earth-line', color: 'text-secondary-500' },
  { label: '校园青春', count: 67, icon: 'ri-school-line', color: 'text-secondary-400' },
  { label: '武侠仙侠', count: 53, icon: 'ri-sword-line', color: 'text-primary-500' },
  { label: '恐怖惊悚', count: 41, icon: 'ri-ghost-line', color: 'text-accent-500' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            完结漫画分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按品类快速定位你想看的完结漫画大全，八大分类应有尽有
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#topics')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/60 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center bg-background-100 ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <span className="block text-sm font-medium text-foreground-900 whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-500">{item.count} 部完结</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}